import React, { useState, useEffect, ChangeEvent } from "react";
import * as yup from "yup";
import { Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { ToastContainer, toast } from "react-toastify";
import useAxiosPost from "../../../hooks/useAxiosPost";
import { notifyError } from "../../toast/Error";
import { notifySuccess } from "../../toast/Success";
import "./../../../assets/styles/olt.css";
import "./../../../assets/styles/ont-list.css";

const CreateNewSlotModelComponent: React.FC<GP> = ({}) => {
  const [
    postCreateNewOLTModelData,
    createNewOLTModelResponseData,
    OLTError,
    OLTLoading,
    COOMessage,
    OLTErrorCount,
  ] = useAxiosPost<CreateNewSlotModelProp>("superAdmin/createNewSlotModel");

  const [
    getBrandsData,
    brandsResponse,
    brandsError,
    brandsLoading,
    brandsMessage,
    brandsErrorCount,
  ] = useAxiosPost<ResponseProp>("superAdmin/brands/getAllBrands");
  useEffect(() => {
    getBrandsData({});
  }, []);
  useEffect(() => {
    if (brandsError !== null && brandsErrorCount !== 0) {
      notifyError(brandsError);
    }
  }, [brandsError, brandsErrorCount]);
  useEffect(() => {
    if (brandsResponse !== null) {
      console.log({ brandsResponse: brandsResponse.responseData });
      setBrands(brandsResponse.responseData || []);
    }
  }, [brandsResponse]);

  const createNewCOOValidationSchema = yup.object().shape({
    businessCardModelName: yup.string().required(),
    intPkBrandID: yup.string().required(),
    numberOfPonports: yup.string().required().oneOf(["8", "16"]),
  });

  useEffect(() => {
    if (OLTError !== null && OLTErrorCount !== 0) {
      notifyError(OLTError);
    }
  }, [OLTError, OLTErrorCount]);
  useEffect(() => {
    if (createNewOLTModelResponseData !== null) {
      const { message } = createNewOLTModelResponseData;
      if (message) {
        notifySuccess(message);
      }
      setTimeout(() => {
        window.location.href = "/all-slot-models";
      }, 5000);
    }
  }, [createNewOLTModelResponseData]);

  const [newSlotModelData, setNewSlotModelData] =
    useState<CreateNewSlotModelProp>({
      businessCardModelName: "",
      intPkBrandID: "",
      numberOfPonports: "",
    });
  const [brands, setBrands] = useState<any>([]);
  const handleCreateCOO = async (event: any) => {
    event.preventDefault();
    const dataToSend: CreateNewSlotModelProp = newSlotModelData;
    try {
      const isValid = await createNewCOOValidationSchema.validate(dataToSend);
      postCreateNewOLTModelData(dataToSend);
    } catch (error: any) {
      notifyError(error.message);
      console.log(error.message);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewSlotModelData({
      ...newSlotModelData,
      [name]: value,
    });
  };
  const renderInput = (name: string, placeholder: string, type: string) => {
    return (
      <>
        <Row className="mt-2">
          <Col md={3} lg={3} xs={12} sm={12} xl={3} xxl={3}></Col>
          <Col md={6} lg={6} xs={12} sm={12} xl={6} xxl={6}>
            <Form.Control
              className="min-height-50p input-shade-gray bd-35p"
              placeholder={`${placeholder}`}
              type={type}
              value={newSlotModelData[name]}
              name={`${name}`}
              onChange={handleInputChange}
            />
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <ToastContainer />
      <Row className="justify-content-center">
        <Col xs lg="12" md="12" xl="12" className="p-5">
          <Card className="p-5">
            <Card.Title className="text-center olt-heading fw-700 pt-3 ">
              {" "}
              New Business Card Model
            </Card.Title>
            <Form className="mt-4">
              {renderInput(
                `businessCardModelName`,
                "Business Card Name",
                `text`
              )}
              {renderInput(`numberOfPonports`, "Number Of PonPorts", `text`)}
              <Row className="mt-2">
                <Col md={3} lg={3} xs={12} sm={12} xl={3} xxl={3}></Col>
                <Col md={6} lg={6} xs={12} sm={12} xl={6} xxl={6}>
                  <Form.Select
                    className="min-height-50p bd-35p"
                    value={newSlotModelData.intPkBrandID}
                    onChange={(e) => {
                      setNewSlotModelData({
                        ...newSlotModelData,
                        intPkBrandID: e.target.value,
                      });
                    }}
                  >
                    <option value={""} key={""}>
                      Choose Brand
                    </option>{" "}
                    {brands.map((item: any) => {
                      return (
                        <option
                          key={item.intPkBrandID}
                          value={item.intPkBrandID}
                        >
                          {item.brandName}
                        </option>
                      );
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={3} lg={3} xs={12} sm={12} xl={3} xxl={3}></Col>
                <Col
                  className="text-center mt-5"
                  md={6}
                  lg={6}
                  xs={12}
                  sm={12}
                  xl={6}
                  xxl={6}
                >
                  <button
                    className="button-primary"
                    type="submit"
                    disabled={OLTLoading}
                    onClick={handleCreateCOO}
                  >
                    Create New
                  </button>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};
export default CreateNewSlotModelComponent;
